import React from 'react';
import {Link} from 'react-router-dom';
import {UserCheck} from 'lucide-react';
import {useMemberAccess} from './MembershipGate';
export default function AdminPendingShortcut({onNavigate}){
 const member=useMemberAccess();
 if(member?.status!=='approved'||member.access_level!=='admin')return null;
 return <div className="border-t px-4 py-3" style={{borderColor:'var(--sy-border)'}}>
  <Link to="/yonetim?durum=bekliyor" onClick={onNavigate} className="flex min-h-[44px] items-center justify-center gap-2 rounded-full px-3 py-2 text-xs font-medium" style={{background:'var(--sy-gold)',color:'var(--sy-bg)'}}><UserCheck size={15} aria-hidden="true"/>Onay Bekleyenler</Link>
 </div>;
}
